import {
  PendingCourseErrorMessageStrategy,
  IAddPendingCourseError
} from './../../strategies/pending_course_error_message_strategy';
import { SitesetupConfiguration } from '../../../sitesetup/config/sitesetup_configuration';
import { TransferTermTypeQuery } from '../../queries/transfer_term_type_query';
import { Strategy } from 'utility-ts-strategy';
import { IPendingCourseFormTileSizeStrategy } from '../../strategies/pending_course_additional_info_strategy';
import * as _4 from 'lodash4';
import { ErrorsDict } from './../../../global/services/form_error_service/form_error_service';
import { TransferGradeQuery } from '../../queries/transfer_grade_query';
import { Grade } from '../../builders/grade_builder';

export interface INewCourse {
  subject: string;
  number: string;
  name: string;
  credits: string;
  term_type: string;
  term_year: string;
  grade: Grade;
}

export class PendingCourseFormTileController {
  private onAdd: (item: INewCourse) => void;
  private isAddEnabled: boolean;
  private uuid = _4.uniqueId();
  private onClose: () => void;
  private newCourse: Partial<INewCourse>;
  private sizesStrategy: IPendingCourseFormTileSizeStrategy;
  private errors: ErrorsDict;

  constructor(
    private ngSitesetupConfiguration: SitesetupConfiguration,
    private ngTransferTermTypeQuery: TransferTermTypeQuery,
    private ngPendingCourseAdditionalInfoStrategy: Strategy<IPendingCourseFormTileSizeStrategy>,
    private ngTransferGradeQuery: TransferGradeQuery
  ) {
    this.sizesStrategy =
      ngPendingCourseAdditionalInfoStrategy[
        this.ngSitesetupConfiguration.isAdditionalPendingCourseInfoEnabled ? 'enable' : 'disable'
      ];
    this.newCourse = {};
  }

  private appendUUID(attr: string) {
    return this.uuid ? attr + this.uuid : undefined;
  }

  private term_onValueChanged($event: CustomEvent) {
    this.newCourse.term_type = $event.detail.value;
  }

  private grade_onValueChanged($event: CustomEvent) {
    this.newCourse.grade = $event.detail.value;
  }

  private getErrorMessage(error: IAddPendingCourseError): string {
    const fallback = () => `Invalid input`;
    return PendingCourseErrorMessageStrategy.evaluate(error, fallback)(error);
  }
}

angular
  .module('capability-ng-transfer')
  .controller('ngPendingCourseFormTileController', PendingCourseFormTileController)
  .component('pendingCourseFormTile', {
    controller: 'ngPendingCourseFormTileController',
    templateUrl: 'lib/transfer/components/pending_course_form_tile/pending_course_form_tile.html',
    controllerAs: '$ctrl',
    bindings: {
      onAdd: '&',
      isAddEnabled: '<',
      onClose: '&',
      errors: '<'
    }
  });



// WEBPACK FOOTER //
// ./app/lib/transfer/components/pending_course_form_tile/pending_course_form_tile.ts